import React, { useState, useEffect } from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import { MapPin, Clock, IndianRupee, Star, Phone, Calendar, Users, Shield, Award, CheckCircle } from 'lucide-react';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import { useNavigate } from 'react-router-dom';


const DelhiToLudhiana = () => {
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const routeData = {
    from: "Delhi",
    to: "Ludhiana",
    distance: "310 km",
    duration: "5-6 hours",
    rating: 4.9,
    startingPrice: 4500,
    reviews: 1250
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TravelAction",
    "name": "Delhi to Ludhiana Taxi Service | Book Cab Online",
    "description": "Book Delhi to Ludhiana taxi with Advait Tour and Travels. 310 km journey in 5-6 hours. Starting at ₹4500. 24/7 service, professional drivers, clean vehicles. Best taxi service from Delhi to Ludhiana.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Advait Tour and Travels",
      "telephone": "+91-7998666660",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "h No -39, new shivpuri",
        "addressLocality": "Ludhiana",
        "addressRegion": "Punjab",
        "addressCountry": "IN"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "1250"
      }
    },
    "fromLocation": {
      "@type": "Place",
      "name": "Delhi",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Delhi",
        "addressRegion": "Delhi",
        "addressCountry": "IN"
      }
    },
    "toLocation": {
      "@type": "Place",
      "name": "Ludhiana",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Ludhiana",
        "addressRegion": "Punjab",
        "addressCountry": "IN"
      }
    },
    "offers": {
      "@type": "Offer",
      "price": "4500",
      "priceCurrency": "INR"
    }
  };

  const vehicles = [
  {
    id: 1,
    name: "Maruti Dzire",
    type: "Sedan",
    capacity: 4,
    luggage: 3,
    price: 4500,
    popular: true,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be7fa069-1768328894291.png",
    imageAlt: "Maruti Dzire taxi for Delhi to Ludhiana route - comfortable 4 seater car",
    features: ["AC", "Music System", "GPS Tracking", "Professional Driver"]
  },
  {
    id: 2,
    name: "Brezza",
    type: "SUV",
    capacity: 4,
    luggage: 4,
    price: 5400,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be7fa069-1768328894291.png",
    imageAlt: "Brezza SUV for Delhi to Ludhiana - spacious 4 seater vehicle",
    features: ["AC", "Music System", "GPS Tracking", "Professional Driver"]
  },
  {
    id: 3,
    name: "Maruti Ertiga",
    type: "MUV",
    capacity: 6,
    luggage: 4,
    price: 5900,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
    imageAlt: "Maruti Ertiga for Delhi to Ludhiana - 6 seater family vehicle",
    features: ["AC", "Music System", "GPS Tracking", "Professional Driver"]
  },
  {
    id: 4,
    name: "Kia Carens",
    type: "MUV",
    capacity: 6,
    luggage: 5,
    price: 6800,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
    imageAlt: "Kia Carens for Delhi to Ludhiana - premium 6 seater",
    features: ["AC", "Music System", "GPS Tracking", "Professional Driver"]
  },
  {
    id: 5,
    name: "Innova Crysta",
    type: "MUV",
    capacity: 6,
    luggage: 6,
    price: 7700,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
    imageAlt: "Innova Crysta for Delhi to Ludhiana - premium 6 seater vehicle",
    features: ["AC", "Music System", "GPS Tracking", "Professional Driver"]
  },
  {
    id: 6,
    name: "Innova Crysta 7+1",
    type: "MUV",
    capacity: 7,
    luggage: 6,
    price: 8100,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ac5f6034-1767621357232.png",
    imageAlt: "Innova Crysta 7+1 for Delhi to Ludhiana - 7 seater with driver",
    features: ["AC", "Music System", "GPS Tracking", "Professional Driver"]
  },
  {
    id: 7,
    name: "Innova Hycross",
    type: "Premium MUV",
    capacity: 6,
    luggage: 5,
    price: 9500,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee6c2ff0-1768328894687.png",
    imageAlt: "Innova Hycross for Delhi to Ludhiana - premium 6 seater luxury vehicle",
    features: ["AC", "Music System", "GPS Tracking", "Professional Driver"]
  }];



  const whyChooseUs = [
  { icon: Shield, title: "Safe & Secure", description: "Verified drivers with background checks" },
  { icon: Award, title: "4.9★ Rated Service", description: "1250+ happy customers on Delhi-Ludhiana route" },
  { icon: Clock, title: "24/7 Availability", description: "Book anytime, travel anytime" },
  { icon: IndianRupee, title: "Best Prices", description: "No hidden charges, transparent pricing" }];


  const faqs = [
  {
    question: "How much does a taxi from Delhi to Ludhiana cost?",
    answer: "Taxi fare from Delhi to Ludhiana starts at ₹6,500 for a sedan. SUV costs ₹9,500 and Tempo Traveller starts at ₹15,500. All prices include toll charges and driver allowance."
  },
  {
    question: "How long does it take to travel from Delhi to Ludhiana by taxi?",
    answer: "The journey from Delhi to Ludhiana takes approximately 5-6 hours by taxi, covering a distance of 310 km via NH44."
  },
  {
    question: "Is advance booking required for Delhi to Ludhiana taxi?",
    answer: "While we offer 24/7 service, advance booking is recommended to ensure vehicle availability, especially during peak seasons and weekends."
  },
  {
    question: "What is included in the Delhi to Ludhiana taxi fare?",
    answer: "The fare includes vehicle charges, driver allowance, toll charges, and state taxes. Parking charges at destinations are extra if applicable."
  },
  {
    question: "Can I book a one-way taxi from Delhi to Ludhiana?",
    answer: "Yes, we offer both one-way and round-trip taxi services from Delhi to Ludhiana at competitive rates."
  }];


  const handleBookNow = (vehicle) => {
    setSelectedVehicle(vehicle);
    navigate('/car-details', {
      state: {
        route: {
          from: 'Delhi',
          to: 'Ludhiana'
        },
        vehicle: vehicle
      }
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Delhi to Ludhiana Taxi | Book Cab Online ₹4500 | Advait Tour and Travels"
        description="Book Delhi to Ludhiana taxi with Advait Tour and Travels. 310 km in 5-6 hours. Starting ₹4500. 24/7 service, professional drivers, clean vehicles. Best taxi service from Delhi to Ludhiana. Call +91-7998666660"
        keywords="delhi to ludhiana taxi, delhi to ludhiana cab, taxi from delhi to ludhiana, cab booking delhi to ludhiana, delhi ludhiana taxi fare, delhi to ludhiana taxi service, delhi to ludhiana car rental, delhi to ludhiana outstation taxi, delhi to ludhiana one way taxi, delhi to ludhiana cab booking online, ludhiana to delhi taxi, ludhiana to delhi cab, taxi from ludhiana to delhi, cab booking ludhiana to delhi, ludhiana delhi taxi fare, ludhiana to delhi taxi service, ludhiana to delhi car rental, ludhiana to delhi outstation taxi, ludhiana to delhi one way taxi"
        canonicalUrl="https://advaitravels.com/delhi-to-ludhiana"
        ogTitle="Delhi to Ludhiana Taxi | Book Cab Online ₹4500"
        ogDescription="Book Delhi to Ludhiana taxi. 310 km in 5-6 hours. Starting ₹4500. 24/7 service, professional drivers. Call +91-7998666660"
        ogUrl="https://advaitravels.com/delhi-to-ludhiana"
        structuredData={structuredData} />

      <Header />

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Delhi to Ludhiana Taxi Service
            </h1>
            <p className="text-xl mb-6">
              Book Cab from Delhi to Ludhiana | 310 km | Starting at ₹6,500
            </p>
            <div className="flex flex-wrap justify-center gap-6 mb-8">
              <div className="flex items-center gap-2">
                <MapPin className="w-5 h-5" />
                <span className="text-lg">310 km</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="w-5 h-5" />
                <span className="text-lg">5-6 hours</span>
              </div>
              <div className="flex items-center gap-2">
                <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                <span className="text-lg">4.9 (1250+ reviews)</span>
              </div>
            </div>
            <div className="flex flex-wrap justify-center gap-4">
              <Button
                onClick={() => window.location.href = 'tel:+917998666660'}
                className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-3 text-lg">

                <Phone className="w-5 h-5 mr-2" />
                Call Now: +91-7998666660
              </Button>
              <Button
                onClick={() => document.getElementById('vehicles')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-yellow-500 text-gray-900 hover:bg-yellow-400 px-8 py-3 text-lg">

                <Calendar className="w-5 h-5 mr-2" />
                Book Now
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-10">
            Why Choose Advait Tour and Travels for Delhi to Ludhiana Taxi?
          </h2>
          <div className="grid md:grid-cols-4 gap-6">
            {whyChooseUs?.map((item, index) => {
              const Icon = item?.icon;
              return (
                <div key={index} className="text-center p-6 rounded-lg border border-gray-200 hover:shadow-lg transition-shadow">
                  <Icon className="w-12 h-12 mx-auto mb-4 text-blue-600" />
                  <h3 className="font-semibold text-lg mb-2">{item?.title}</h3>
                  <p className="text-gray-600 text-sm">{item?.description}</p>
                </div>);

            })}
          </div>
        </div>
      </div>

      {/* Vehicle Options */}
      <div id="vehicles" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-4">
            Delhi to Ludhiana Taxi Fare & Vehicle Options
          </h2>
          <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto">
            Choose from our wide range of vehicles for your Delhi to Ludhiana journey. All fares include toll charges and driver allowance.
          </p>
          <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {vehicles?.map((vehicle) =>
            <div key={vehicle?.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow">
                {vehicle?.popular &&
              <div className="bg-yellow-500 text-gray-900 text-center py-1 font-semibold text-sm">
                    MOST POPULAR
                  </div>
              }
                <img
                src={vehicle?.image}
                alt={vehicle?.imageAlt}
                className="w-full h-48 object-cover" />

                <div className="p-6">
                  <h3 className="text-2xl font-bold mb-2">{vehicle?.name}</h3>
                  <p className="text-gray-600 mb-4">{vehicle?.type}</p>
                  <div className="flex items-center gap-4 mb-4 text-sm text-gray-600">
                    <div className="flex items-center gap-1">
                      <Users className="w-4 h-4" />
                      <span>{vehicle?.capacity} Seats</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <MapPin className="w-4 h-4" />
                      <span>{vehicle?.luggage} Bags</span>
                    </div>
                  </div>
                  <div className="mb-4">
                    {vehicle?.features?.map((feature, idx) =>
                  <div key={idx} className="flex items-center gap-2 text-sm text-gray-700 mb-1">
                        <CheckCircle className="w-4 h-4 text-green-600" />
                        <span>{feature}</span>
                      </div>
                  )}
                  </div>
                  <div className="border-t pt-4">
                    <div className="flex items-baseline gap-2 mb-4">
                      <span className="text-3xl font-bold text-blue-600">₹{vehicle?.price}</span>
                      {vehicle?.originalPrice &&
                    <span className="text-lg text-gray-400 line-through">₹{vehicle?.originalPrice}</span>
                    }
                    </div>
                    <Button
                    onClick={() => handleBookNow(vehicle)}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3">

                      Book {vehicle?.name} Now
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Route Information */}
      <div className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-6">
              About Delhi to Ludhiana Taxi Route
            </h2>
            <div className="prose max-w-none">
              <p className="text-gray-700 mb-4">
                The <strong>Delhi to Ludhiana taxi route</strong> is one of the most popular travel corridors connecting the national capital with Punjab's industrial hub. This 310 km journey via NH44 takes approximately 5-6 hours, offering a comfortable and convenient travel option for both business and leisure travelers.
              </p>
              <p className="text-gray-700 mb-4">
                When you <strong>book a cab from Delhi to Ludhiana</strong> with Advait Tour and Travels, you get professional drivers who are well-versed with the route, ensuring a safe and timely journey. Our <strong>Delhi to Ludhiana taxi service</strong> operates 24/7, allowing you to travel at your convenience.
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4">
                Delhi to Ludhiana Taxi Fare Details
              </h3>
              <p className="text-gray-700 mb-4">
                Our <strong>Delhi to Ludhiana cab fare</strong> starts at just ₹6,500 for a sedan, making it one of the most affordable options for this route. The fare includes:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-700">
                <li>Vehicle charges for the entire journey</li>
                <li>Professional driver with excellent route knowledge</li>
                <li>All toll charges on Delhi to Ludhiana highway</li>
                <li>Driver allowance and state taxes</li>
                <li>GPS tracking for safety</li>
                <li>24/7 customer support</li>
              </ul>
              <h3 className="text-2xl font-bold mt-8 mb-4">
                Best Time to Travel from Delhi to Ludhiana
              </h3>
              <p className="text-gray-700 mb-4">
                The best time to travel from Delhi to Ludhiana by taxi is early morning (5-7 AM) or late evening (after 8 PM) to avoid traffic congestion. The highway is well-maintained throughout the year, making it suitable for travel in all seasons.
              </p>
              <h3 className="text-2xl font-bold mt-8 mb-4">
                Popular Stops on Delhi to Ludhiana Route
              </h3>
              <ul className="list-disc pl-6 mb-4 text-gray-700">
                <li><strong>Karnal</strong> - Famous for its dhabas and restaurants (90 km from Delhi)</li>
                <li><strong>Ambala</strong> - Major stopover point with good facilities (200 km from Delhi)</li>
                <li><strong>Rajpura</strong> - Last major town before Ludhiana (280 km from Delhi)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* FAQs */}
      <div className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-center">
              Frequently Asked Questions - Delhi to Ludhiana Taxi
            </h2>
            <div className="space-y-4">
              {faqs?.map((faq, index) =>
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm">
                  <h3 className="font-semibold text-lg mb-2">{faq?.question}</h3>
                  <p className="text-gray-700">{faq?.answer}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-12 bg-blue-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Ready to Book Your Delhi to Ludhiana Taxi?
          </h2>
          <p className="text-xl mb-8">
            Call us now or book online for the best Delhi to Ludhiana cab service
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button
              onClick={() => window.location.href = 'tel:+917998666660'}
              className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-3 text-lg">

              <Phone className="w-5 h-5 mr-2" />
              Call: +91-7998666660
            </Button>
            <Button
              onClick={() => window.location.href = 'https://wa.me/917998666660'}
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-3 text-lg">

              WhatsApp Us
            </Button>
          </div>
        </div>
      </div>

      <Footer />
    </div>);

};

export default DelhiToLudhiana;